export default function classNames(...classes) {
    return classes.map(applyStyles).flat().filter(Boolean).join(' ')
}

function applyStyles(styles) {
    if (typeof styles != 'object') {
        return styles
    }

    return Object.keys(styles).filter(style => !!styles[style])
}
